import React, { Component } from "react";

import Signbutton from "../../forms/button";
import { Input } from "../../forms/input";
import { connect } from "react-redux";
import { Paper } from "@material-ui/core";
import { NPS_URL } from "./index";
import { saveNpsBankDetails } from "../../../store/actions/nps";

class NpsBankDetails extends Component {
  constructor(props) {
    super(props);
    const BankDetails = this.props.Nps_Bank_Details || {};
    this.state = {
      AccountNumber: { value: BankDetails.AccountNumber || "" },
      IFSC: { value: BankDetails.IFSC || "" },
      BankName: { value: BankDetails.BankName || "" },
      Branch: { value: BankDetails.Branch || "" },
    };
  }
  handleChange = (label) => (event) => {
    if (label === "Branch") {
      this.setState({
        [label]: { value: event.target.value },
        BankAddress: {
          value: event.target.value,
        },
      });
    } else if (label === "IFSC") {
      this.setState({
        [label]: { value: event.target.value.toUpperCase() },
      });
    } else {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };
  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;
    this.setState({
      [label]: {
        value,
        isError: !value,
        errorMessage:
          label === "BankName"
            ? "Bank Name is Mandatory*"
            : label === "IFSC"
            ? "IFSC Number is Mandatory*"
            : label === "AccountNumber"
            ? "Account Number is Mandatory*"
            : label === "Branch"
            ? "Branch Name is Mandatory*"
            : "",
      },
    });
    if (
      !!this.state.AccountNumber.value &&
      !/^\d{9,18}$/.test(this.state.AccountNumber.value)
    ) {
      this.setState({
        AccountNumber: {
          value: this.state.AccountNumber.value,
          isError: true,
          errorMessage: "Enter a Valid BankAccountNumber",
        },
      });
      return;
    } else if (
      !!this.state.BankName.value &&
      !/^[a-zA-Z ]+$/.test(this.state.BankName.value)
    ) {
      this.setState({
        BankName: {
          value: this.state.BankName.value,
          isError: true,
          errorMessage: "Enter a Valid Bank Name",
        },
      });
      return;
    } else if (
      !!this.state.IFSC.value &&
      !/^[A-Z]{4}[0][A-Z0-9]{6}$/.test(this.state.IFSC.value)
    ) {
      this.setState({
        IFSC: {
          value: this.state.IFSC.value,
          isError: true,
          errorMessage: "Enter a Valid IFSC code",
        },
      });
      return;
    } else if (
      !!this.state.Branch.value &&
      !/^[a-zA-Z0-9 ]+$/.test(this.state.Branch.value)
    ) {
      this.setState({
        Branch: {
          value: this.state.Branch.value,
          isError: true,
          errorMessage: "Enter a Valid Branch Name",
        },
      });
      return;
    }
  };
  submit = () => {
    const { ...others } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => others[key].value !== "");

    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              isShowError: true,
              errorMessage:
                key === "BankName"
                  ? "Bank Name is Mandatory*"
                  : key === "IFSC"
                  ? "IFSC Number is Mandatory*"
                  : key === "AccountNumber"
                  ? "Account Number is Mandatory*"
                  : key === "Branch"
                  ? "Branch Name is Mandatory*"
                  : "",
            },
          });
      });
      return;
    } else if (!/^\d{9,18}$/.test(this.state.AccountNumber.value)) {
      this.setState({
        AccountNumber: {
          value: this.state.AccountNumber.value,
          isError: true,
          errorMessage: "Enter a Valid Bank Account Number",
        },
      });
      return;
    } else if (!/^[a-zA-Z ]+$/.test(this.state.BankName.value)) {
      this.setState({
        BankName: {
          value: this.state.BankName.value,
          isError: true,
          errorMessage: "Enter a Valid Bank Name",
        },
      });
      return;
    } else if (!/^[A-Z]{4}[0][A-Z0-9]{6}$/.test(this.state.IFSC.value)) {
      this.setState({
        IFSC: {
          value: this.state.IFSC.value,
          isError: true,
          errorMessage: "Enter a Valid IFSC code",
        },
      });
      return;
    } else if (
      !!this.state.Branch.value &&
      !/^[a-zA-Z0-9 ]+$/.test(this.state.Branch.value)
    ) {
      this.setState({
        Branch: {
          value: this.state.Branch.value,
          isError: true,
          errorMessage: "Enter a Valid Branch Name",
        },
      });
      return;
    }

    const BankDetails = {
      AccountNumber: this.state.AccountNumber.value,
      IFSC: this.state.IFSC.value,
      BankName: this.state.BankName.value,
      Branch: this.state.Branch.value,
    };
    this.props.saveNpsBankDetails(BankDetails);
    this.props.history.push(NPS_URL + "/onlineEmpanelement/upload");
  };
  render() {
    const { Nps_Rejection_Details } = this.props;
    const { RejectionBank, RejectionMessage } = Nps_Rejection_Details;
    return (
      <div className="container-margin">
        <div className="customer-support-email">
          Customer Support Email :{" "}
          <a href="mailto:npsdistributorsupport@kfintech.com">
            npsdistributorsupport@kfintech.com
          </a>
        </div>
        {!!RejectionBank && (
          <div className="nps-rejected-message">
            {`Your application was rejected by ${RejectionBank} for the reason : ${RejectionMessage}`}
          </div>
        )}
        <div className="investor-title">Online Empanelment</div>
        <Paper className="digital-form-container">
          <div className="digital-form-Right-div-for-nps">
            <div
              className="investor-title"
              style={{
                fontWeight: 450,
                marginTop: 20,
                marginBottom: 30,
                marginLeft: 20,
              }}
            >
              {" "}
              Bank Details
            </div>
            <div className="transaction-details">
              <div className="input-margin flex">
                <div className="appbar-div dual-margin ">
                  <div className="input-name">Bank Name*</div>
                  <div style={{ marginTop: 10 }}>
                    <Input
                      name=""
                      value={this.state.BankName.value}
                      onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                      onBlur={this.showError("BankName")}
                      onChange={this.handleChange("BankName")}
                      placeholder="Enter Bank Name"
                      style={{ fontFamily: "OpenSans-Regular" }}
                      isError={this.state.BankName.isError}
                      isShowError={this.state.BankName.isError}
                      errorMessage={this.state.BankName.errorMessage}
                      inputref={(ele) => (this.banknameField = ele)}
                    />
                  </div>
                </div>
                <div className="appbar-div dual-margin bank-responsive">
                  <div className="input-name">Account Number*</div>
                  <div style={{ marginTop: 10 }}>
                    <Input
                      name=""
                      onChange={this.handleChange("AccountNumber")}
                      onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                      isError={this.state.AccountNumber.isError}
                      isShowError={this.state.AccountNumber.isError}
                      errorMessage={this.state.AccountNumber.errorMessage}
                      type="number"
                      value={this.state.AccountNumber.value}
                      onBlur={this.showError("AccountNumber")}
                      placeholder="Enter your Bank Account No"
                      style={{ fontFamily: "OpenSans-Regular" }}
                      inputref={(ele) => (this.bankaccField = ele)}
                    />
                  </div>
                </div>
              </div>
              <div className="input-margin flex">
                <div className="appbar-div dual-margin bank-responsive">
                  <div className="input-name">IFSC*</div>
                  <div style={{ marginTop: 10 }}>
                    <Input
                      name=""
                      value={this.state.IFSC.value}
                      onBlur={this.showError("IFSC")}
                      onChange={this.handleChange("IFSC")}
                      onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                      placeholder="Enter your  IFSC No"
                      style={{ fontFamily: "OpenSans-Regular" }}
                      isError={this.state.IFSC.isError}
                      isShowError={this.state.IFSC.isError}
                      errorMessage={this.state.IFSC.errorMessage}
                      inputref={(ele) => (this.bankifscField = ele)}
                    />
                  </div>
                </div>
                <div className="appbar-div dual-margin bank-responsive">
                  <div className="input-name">Branch*</div>
                  <div style={{ marginTop: 10 }}>
                    <Input
                      name=""
                      value={this.state.Branch.value}
                      onBlur={this.showError("Branch")}
                      onChange={this.handleChange("Branch")}
                      onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                      placeholder="Enter Bank Branch Name"
                      style={{ fontFamily: "OpenSans-Regular" }}
                      inputref={(ele) => (this.bankbranchField = ele)}
                      isError={this.state.Branch.isError}
                      isShowError={this.state.Branch.isError}
                      errorMessage={this.state.Branch.errorMessage}
                    />
                  </div>
                </div>
              </div>
              <div className="digital-form-button-next-div">
                <Signbutton
                  buttontitle="Save and Proceed"
                  onClick={this.submit}
                />
              </div>
              <div className="input-margin flex">
                <div className="appbar-div dual-margin mouse-pointer ">
                  <span
                    className="input-name"
                    onClick={() =>
                      this.props.history.push(
                        NPS_URL + "/onlineEmpanelement/basicDetails"
                      )
                    }
                    style={{
                      color: "#007bff",
                      marginTop: "20px",
                    }}
                  >
                    {"Back to Basic Details page"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}
export default connect(
  ({ authReducer, npsReducer }) => {
    const { token } = authReducer;
    const { Nps_Bank_Details, Nps_Rejection_Details } = npsReducer;
    return { token, Nps_Bank_Details, Nps_Rejection_Details };
  },
  { saveNpsBankDetails }
)(NpsBankDetails);
